import { OfficeMember } from '@/components/OfficeMember';
import { BaseOption } from '@/hooks/useTypeToOptions';
import { useTranslation } from '@/i18n';
import {
  ListView,
  ListViewLabel,
  ListViewProps,
  Single,
} from '@moneyforward/ap-frontend-components';
import { FC, memo, useCallback } from 'react';
import { useForm } from 'react-hook-form';

export type Props = {
  container?: HTMLElement | null;
  selectedItems?: string[];
  // onSelectedItems?: (officeMemberIds: string[]) => void;
  defaultOptions?: BaseOption[];
};

const LEFT_RIGHT_RATIO: ListViewProps['leftRightRatio'] = {
  left: { max: '240px', min: '240px' },
  right: { max: 'none' },
};

const SELECT_PROPS = { style: { width: '100%' } };

type FormValues = {
  viewers: string[];
};

const InnerViewerSelect: FC<Props> = memo(
  ({ selectedItems, defaultOptions }) => {
    const { t } = useTranslation();
    const { control } = useForm<FormValues>({
      defaultValues: { viewers: selectedItems ?? [] },
    });
    const onChangeAfter = useCallback(
      (value: string | number | (string | number)[]) => {
        const values = Array.isArray(value) ? value : [value];
        const ev = new CustomEvent('wc.ap.viewer.onchange', {
          detail: values,
          bubbles: true,
        });
        window.dispatchEvent(ev);
      },
      []
    );

    return (
      <ListView leftRightRatio={LEFT_RIGHT_RATIO}>
        <Single>
          <ListViewLabel key='left'>{t('viewer_select_label')}</ListViewLabel>
          <OfficeMember<FormValues>
            control={control}
            name='viewers'
            inputId='viewers'
            defaultOptions={defaultOptions}
            selectProps={SELECT_PROPS}
            onChangeAfter={onChangeAfter}
          />
        </Single>
      </ListView>
    );
  }
);
InnerViewerSelect.displayName = 'InnerViewerSelect';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const ViewerSelect = memo((props: Props) => (
  <InnerViewerSelect {...props} />
)) as FC<Props>;
ViewerSelect.displayName = 'ViewerSelect';
